export default __webpack_public_path__ + "static/media/FAB.527cdde1.svg";